const config = {
  api: "https://api.e.report",
  nxpage: 15,
};

module.exports = config;
